import type { ReactNode } from "react";

type Kind = "default" | "enabled" | "paused" | "warn" | "neg" | "accent";

export function Badge({
  kind = "default",
  children,
}: {
  kind?: Kind;
  children: ReactNode;
}) {
  const cls = kind === "default" ? "badge" : `badge ${kind}`;
  return <span className={cls}>{children}</span>;
}

/** ASA campaign / ad_group / keyword status badge. */
export function StatusBadge({ status }: { status: string | null | undefined }) {
  if (status === "ENABLED" || status === "ACTIVE") {
    return (
      <Badge kind="enabled">
        <span className="dot" />
        Active
      </Badge>
    );
  }
  return (
    <Badge kind="paused">
      <span className="dot" style={{ background: "var(--c-text-4)" }} />
      Paused
    </Badge>
  );
}
